/* ==========================================================================
   Velocify · Experiência de conta (tema XOGANG)
   Fala SOMENTE com o Worker ogjersey-conta (Bearer token em localStorage).
   Sem OAuth/CA API — o storefront nunca vê segredo.
   Identidade SEMPRE validada via GET /api/me/profile antes de renderizar.
   MARKER: VF-ACCOUNT-JS-MARKER-20261002
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.VF_ACCOUNT || {};
  var API = String(CFG.api || '').replace(/\/+$/, '');
  var PAGES = CFG.pages || {};
  var LOGIN_URL = CFG.loginUrl || '/pages/login';
  var HOME_URL = CFG.homeUrl || '/';
  var DASH_URL = PAGES.dashboard || '/pages/minha-conta';
  var TOKEN_KEY = 'vf_token';
  var PENDING_KEY = 'vf_pending';
  var USER_KEY = 'vf_user';

  /* --------------------------------- Utils -------------------------------- */

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === 'text') node.textContent = attrs[k];
        else if (k === 'html') node.innerHTML = attrs[k];
        else if (k === 'class') node.className = attrs[k];
        else if (k.slice(0, 2) === 'on' && typeof attrs[k] === 'function') node.addEventListener(k.slice(2), attrs[k]);
        else if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) node.setAttribute(k, attrs[k]);
      });
    }
    (children || []).forEach(function (c) {
      if (c === null || c === undefined) return;
      node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return node;
  }

  function esc(s) {
    return String(s === null || s === undefined ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function money(amount, currency) {
    var n = parseFloat(amount);
    if (isNaN(n)) n = 0;
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency || 'BRL' }).format(n);
    } catch (e) {
      return 'R$ ' + n.toFixed(2).replace('.', ',');
    }
  }

  function date(iso) {
    if (!iso) return '—';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }) +
      ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  }

  function dateOnly(iso) {
    if (!iso) return '—';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  function e164(v) {
    var digits = String(v || '').replace(/\D/g, '');
    return digits ? '+' + digits : '';
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var a = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, a); }, wait || 300);
    };
  }

  function emailOk(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim());
  }

  var ERRORS = {
    invalid_credentials: 'E-mail ou senha incorretos.',
    exists: 'Já existe uma conta com este e-mail.',
    not_exists: 'Não encontramos uma conta com este e-mail.',
    invalid_code: 'Código incorreto. Confira o e-mail e tente novamente.',
    otp_expired: 'Este código expirou. Peça um novo.',
    otp_locked: 'Muitas tentativas. Aguarde alguns minutos e tente de novo.',
    rate_limited: 'Muitas tentativas. Aguarde alguns minutos e tente de novo.',
    weak_password: 'A senha precisa ter no mínimo 8 caracteres.',
    invalid_email: 'Informe um e-mail válido.',
    email_failed: 'Não foi possível enviar o e-mail agora. Tente novamente em instantes.',
    email_required: 'Informe seu e-mail.',
    password_required: 'Informe a senha.',
    password_mismatch: 'As senhas não conferem.',
    code_required: 'Informe o código de 6 dígitos.',
    not_linked: 'Sincronização com a loja indisponível no momento.',
    http_401: 'Sua sessão expirou. Entre novamente.',
    http_429: 'Muitas tentativas. Aguarde alguns minutos.',
    http_500: 'Erro no servidor. Tente novamente.',
    network: 'Falha de conexão. Verifique sua internet.'
  };

  function msg(err) {
    if (!err) return '';
    var code = err.code || '';
    return ERRORS[code] || (code.indexOf('http_') === 0 ? ERRORS[code] || 'Erro inesperado.' : (err.message || 'Erro inesperado.'));
  }

  /* -------------------------------- Storage -------------------------------- */

  function getToken() {
    try { return localStorage.getItem(TOKEN_KEY) || ''; } catch (e) { return ''; }
  }

  function setToken(t) {
    try { t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY); } catch (e) { /* noop */ }
  }

  function getCachedUser() {
    try { return JSON.parse(sessionStorage.getItem(USER_KEY) || 'null'); } catch (e) { return null; }
  }

  function setCachedUser(u) {
    try { u ? sessionStorage.setItem(USER_KEY, JSON.stringify(u)) : sessionStorage.removeItem(USER_KEY); } catch (e) { /* noop */ }
  }

  function getPending() {
    try { return JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null'); } catch (e) { return null; }
  }

  function setPending(p) {
    try { p ? sessionStorage.setItem(PENDING_KEY, JSON.stringify(p)) : sessionStorage.removeItem(PENDING_KEY); } catch (e) { /* noop */ }
  }

  /* Remove TODA chave vf_* de localStorage e sessionStorage.
     Usado em troca de conta, logout e sessão inválida — assim nunca sobra
     identidade (vf_name, vf_user, vf_token, vf_pending…) de outra conta. */
  function clearVfStorage() {
    [window.localStorage, window.sessionStorage].forEach(function (store) {
      try {
        var kill = [];
        for (var i = 0; i < store.length; i++) {
          var k = store.key(i);
          if (k && k.indexOf('vf_') === 0) kill.push(k);
        }
        kill.forEach(function (k) { store.removeItem(k); });
      } catch (e) { /* noop */ }
    });
  }

  /* ---------------------------------- API ---------------------------------- */

  function api(path, opts) {
    opts = opts || {};
    if (!API) {
      return Promise.reject(new Error('VF_ACCOUNT.api não configurado'));
    }
    var headers = { 'Accept': 'application/json' };
    if (opts.body) headers['Content-Type'] = 'application/json';
    var token = getToken();
    if (token) headers['Authorization'] = 'Bearer ' + token;

    return fetch(API + path, {
      method: opts.method || 'GET',
      headers: headers,
      body: opts.body ? JSON.stringify(opts.body) : undefined
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var e = new Error(j.message || 'HTTP ' + r.status);
          e.code = j.error || 'http_' + r.status;
          e.status = r.status;
          if (r.status === 401) e.unauthorized = true;
          throw e;
        }
        return j;
      });
    }).catch(function (err) {
      if (err && err.code) throw err;
      var e = new Error('Falha de conexão');
      e.code = 'network';
      throw e;
    });
  }

  /* --------------------------- Autenticação (páginas) ---------------------- */

  function session() {
    if (!getToken()) return Promise.resolve(null);
    /* Valida o token contra /api/me/profile (identidade fresca).
       401/403 → limpa TODA a identidade cacheada e resolve null. */
    return api('/api/me/profile').then(function (p) {
      if (!p) return null;
      setCachedUser(p);
      return p;
    }).catch(function (e) {
      if (e.unauthorized || e.status === 401 || e.status === 403) {
        clearVfStorage();
        return null;
      }
      throw e;
    });
  }

  function login(email, password) {
    return api('/api/auth/login', { method: 'POST', body: { email: email, password: password } });
  }

  function register(payload) {
    return api('/api/auth/register', { method: 'POST', body: payload });
  }

  function requestOtp(email, purpose) {
    return api('/api/auth/otp', { method: 'POST', body: { email: email, purpose: purpose } });
  }

  function verifyOtp(email, code, purpose) {
    return api('/api/auth/verify', { method: 'POST', body: { email: email, code: code, purpose: purpose } });
  }

  function forgot(email) {
    return api('/api/auth/forgot', { method: 'POST', body: { email: email } });
  }

  function resetPassword(resetToken, password) {
    return api('/api/auth/password', { method: 'POST', body: { resetToken: resetToken, password: password } });
  }

  function logout() {
    return api('/api/auth/logout', { method: 'POST' }).catch(function () { /* best effort */ }).then(function () {
      clearVfStorage();
      location.href = HOME_URL;
    });
  }

  function goDashboard() {
    location.href = DASH_URL;
  }

  function errorMessage(err, fallback) {
    return (err && err.message) || fallback || 'Erro inesperado.';
  }

  /* --------------------------- Login: passo a passo ------------------------ */

  function bootLogin(root) {
    var msgEl = $('[data-vf-step-msg]', root) || $('[data-vf-login-msg]', root);
    var pending = new URLSearchParams(location.search);
    var initialErr = pending.get('err');
    var justOut = pending.get('out');

    function setMsg(text, tone) {
      if (!msgEl) return;
      msgEl.textContent = text || '';
      msgEl.className = 'vf-note' + (tone ? ' vf-note--' + tone : '');
    }

    function showStep(name) {
      $all('[data-vf-step]', root).forEach(function (s) {
        s.hidden = s.getAttribute('data-vf-step') !== name;
      });
      var active = $('[data-vf-step="' + name + '"]:not([hidden]) [data-vf-step-msg]', root);
      msgEl = active || msgEl;
      setMsg('');
      if (history.replaceState) history.replaceState(null, '', LOGIN_URL + (name === 'login' ? '' : '#' + name));
      var first = $('[data-vf-step="' + name + '"]:not([hidden]) input');
      if (first) setTimeout(function () { first.focus(); }, 50);
    }

    function currentStep() {
      var h = (location.hash || '').replace('#', '');
      return ['register', 'otp', 'reset'].indexOf(h) >= 0 ? h : 'login';
    }

    function handleResult(res) {
      if (res && res.token) {
        /* Troca de conta: APAGA qualquer identidade anterior (vf_name,
           vf_user, vf_pending…) ANTES de gravar o token novo, e só então
           grava o token + usuário fresco vindos da API. */
        clearVfStorage();
        setToken(res.token);
        if (res.user) setCachedUser(res.user);
        goDashboard();
        return true;
      }
      if (res && res.needsVerification) {
        setPending({ email: res.email, purpose: res.purpose || 'login' });
        setMsg('');
        $('[data-vf-otp-email]').textContent = res.email;
        showStep('otp');
        return true;
      }
      return false;
    }

    /* forms */
    var loginForm = $('[data-vf-login-form]', root);
    if (loginForm) {
      loginForm.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var fd = new FormData(loginForm);
        var email = String(fd.get('email') || '').trim();
        var password = String(fd.get('password') || '');
        if (!emailOk(email)) { setMsg(ERRORS.invalid_email, 'error'); return; }
        if (!password) { setMsg(ERRORS.password_required, 'error'); return; }
        var btn = $('button[type=submit]', loginForm);
        btn.disabled = true;
        login(email, password).then(function (res) {
          btn.disabled = false;
          if (!handleResult(res)) setMsg(ERRORS.invalid_credentials, 'error');
        }).catch(function (err) {
          btn.disabled = false;
          if (err.code === 'invalid_credentials' || err.code === 'not_exists' || (err.status === 404)) setMsg(ERRORS.invalid_credentials, 'error');
          else setMsg(msg(err), 'error');
        });
      });
    }

    var regForm = $('[data-vf-register-form]', root);
    if (regForm) {
      regForm.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var fd = new FormData(regForm);
        var email = String(fd.get('email') || '').trim();
        var password = String(fd.get('password') || '');
        if (!emailOk(email)) { setMsg(ERRORS.invalid_email, 'error'); return; }
        if (!password || password.length < 8) { setMsg(ERRORS.weak_password, 'error'); return; }
        var btn = $('button[type=submit]', regForm);
        btn.disabled = true;
        register({
          email: email,
          password: password,
          firstName: String(fd.get('firstName') || '').trim(),
          lastName: String(fd.get('lastName') || '').trim()
        }).then(function (res) {
          btn.disabled = false;
          if (!handleResult(res)) setMsg('Não foi possível criar a conta.', 'error');
        }).catch(function (err) {
          btn.disabled = false;
          if (err.code === 'exists') setMsg(ERRORS.exists + ' Use "Entrar" ou recupere a senha.', 'error');
          else setMsg(msg(err), 'error');
        });
      });
    }

    var otpForm = $('[data-vf-otp-form]', root);
    if (otpForm) {
      otpForm.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var p = getPending();
        if (!p || !p.email) { setMsg('Sessão de verificação expirada. Comece de novo.', 'error'); showStep('login'); return; }
        var code = String(new FormData(otpForm).get('code') || '').replace(/\D/g, '');
        if (code.length !== 6) { setMsg(ERRORS.code_required, 'error'); return; }
        var btn = $('button[type=submit]', otpForm);
        btn.disabled = true;
        verifyOtp(p.email, code, p.purpose || 'login').then(function (res) {
          btn.disabled = false;
          if (res && res.resetToken) {
            setPending({ email: p.email, purpose: 'reset', resetToken: res.resetToken });
            showStep('reset');
            return;
          }
          if (!handleResult(res)) setMsg('Verificação falhou. Tente novamente.', 'error');
        }).catch(function (err) {
          btn.disabled = false;
          if (err.code === 'otp_expired') { setMsg(ERRORS.otp_expired, 'error'); return; }
          setMsg(msg(err), 'error');
        });
      });

      var resend = $('[data-vf-otp-resend]', root);
      if (resend) {
        resend.addEventListener('click', function () {
          var p = getPending();
          if (!p || !p.email) { showStep('login'); return; }
          resend.disabled = true;
          requestOtp(p.email, p.purpose || 'login').then(function () {
            resend.disabled = false;
            setMsg('Novo código enviado para ' + p.email + '.', 'ok');
          }).catch(function (err) {
            resend.disabled = false;
            setMsg(msg(err), 'error');
          });
        });
      }
    }

    var resetForm = $('[data-vf-reset-form]', root);
    if (resetForm) {
      resetForm.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var p = getPending();
        if (!p || !p.resetToken) { setMsg('Sessão expirada. Solicite a recuperação de novo.', 'error'); showStep('login'); return; }
        var fd = new FormData(resetForm);
        var password = String(fd.get('password') || '');
        var password2 = String(fd.get('password2') || '');
        if (!password || password.length < 8) { setMsg(ERRORS.weak_password, 'error'); return; }
        if (password !== password2) { setMsg(ERRORS.password_mismatch, 'error'); return; }
        var btn = $('button[type=submit]', resetForm);
        btn.disabled = true;
        resetPassword(p.resetToken, password).then(function (res) {
          btn.disabled = false;
          if (!handleResult(res)) setMsg('Não foi possível salvar a senha.', 'error');
        }).catch(function (err) {
          btn.disabled = false;
          setMsg(msg(err), 'error');
        });
      });
    }

    /* esqueci a senha */
    var forgotLink = $('[data-vf-goto="forgot"]', root);
    if (forgotLink) {
      forgotLink.addEventListener('click', function (ev) {
        ev.preventDefault();
        var email = String(($('#vf-login-email', root) || {}).value || '').trim();
        if (!emailOk(email)) { showStep('login'); setMsg('Informe seu e-mail no campo acima para recuperar a senha.', 'error'); $('#vf-login-email', root) && $('#vf-login-email', root).focus(); return; }
        forgot(email).then(function () {
          setPending({ email: email, purpose: 'reset' });
          $('[data-vf-otp-email]').textContent = email;
          showStep('otp');
          setMsg('Se existir uma conta, enviamos o código. Confira seu e-mail.', 'ok');
        }).catch(function (err) { setMsg(msg(err), 'error'); });
      });
    }

    /* navegação de passos */
    $all('[data-vf-goto]', root).forEach(function (btn) {
      if (btn.getAttribute('data-vf-goto') === 'forgot') return;
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        showStep(btn.getAttribute('data-vf-goto'));
      });
    });

    showStep(currentStep());

    /* Mensagem inicial DEPOIS do showStep, que zera o node do passo ativo. */
    if (initialErr) setMsg(ERRORS[initialErr] || 'Não foi possível completar a operação.');
    else if (justOut) setMsg('Sua sessão expirou ou você saiu da conta. Entre novamente.', 'warn');

    /* Já logado? Valida o token com /api/me/profile:
       válido → painel; inválido → clearVfStorage + fica no form (sem dado velho). */
    var hadToken = !!getToken();
    session().then(function (u) {
      if (u) { goDashboard(); return; }
      if (hadToken && !initialErr && !justOut) {
        setMsg('Sua sessão expirou ou não é válida. Entre novamente.', 'warn');
      }
    }).catch(function () { /* continua no login */ });
  }

  /* --------------------------- Páginas protegidas -------------------------- */

  function ensureAuth(root, view) {
    if (!getToken()) {
      clearVfStorage();
      location.replace(LOGIN_URL + '?out=1');
      return Promise.resolve(false);
    }
    return session().then(function (u) {
      if (!u) {
        /* session() já limpou toda a identidade cacheada no 401 */
        location.replace(LOGIN_URL + '?out=1');
        return false;
      }
      root.__vfUser = u;
      return true;
    }).catch(function (e) {
      if (e.unauthorized || e.status === 401 || e.status === 403) {
        clearVfStorage();
        location.replace(LOGIN_URL + '?out=1');
        return false;
      }
      viewError(view, e);
      return false;
    });
  }

  function skeleton(view) {
    view.innerHTML =
      '<div class="vf-skeleton" aria-hidden="true">' +
      '<div class="vf-skeleton__block vf-skeleton__block--title"></div>' +
      '<div class="vf-skeleton__block"></div>' +
      '<div class="vf-skeleton__block vf-skeleton__block--card"></div>' +
      '</div>' +
      '<p class="vf-meta" role="status">Carregando sua conta…</p>';
  }

  function viewError(view, err) {
    view.innerHTML = '';
    var alert = el('div', { class: 'vf-alert vf-alert--error', role: 'alert' }, [
      el('strong', { text: 'Não foi possível carregar' }),
      el('span', { text: ' ' + msg(err) })
    ]);
    var retry = el('button', { class: 'vf-btn vf-btn--secondary vf-btn--sm', type: 'button', text: 'Tentar de novo', onclick: function () { location.reload(); } });
    view.appendChild(alert);
    view.appendChild(el('div', { class: 'vf-actions', style: 'margin-top:14px' }, [retry]));
  }

  /* --------------------------- Adaptadores de dados ------------------------ */

  var COUNTRY_NAMES = {
    BR: 'Brasil', US: 'Estados Unidos', PT: 'Portugal', AR: 'Argentina',
    ES: 'Espanha', FR: 'França', IT: 'Itália', DE: 'Alemanha', JP: 'Japão'
  };

  function adaptAddress(a) {
    return {
      id: a.id,
      firstName: a.firstName || '',
      lastName: a.lastName || '',
      company: a.company || '',
      address1: a.address1 || '',
      address2: a.address2 || '',
      city: a.city || '',
      province: a.province || '',
      zoneCode: a.province || '',
      zip: a.zip || '',
      countryCode: a.countryCode || 'BR',
      country: a.country || COUNTRY_NAMES[a.countryCode] || a.countryCode || '',
      phoneNumber: a.phone || '',
      isDefault: !!a.isDefault
    };
  }

  function adaptOrder(o) {
    var currency = o.currency || 'BRL';
    return {
      id: o.id || o.name,
      name: o.name || ('#' + o.id),
      createdAt: o.createdAt,
      processedAt: o.createdAt,
      financialStatus: String(o.financialStatus || '').toUpperCase(),
      fulfillmentStatus: String(o.fulfillmentStatus || '').toUpperCase(),
      totalPrice: { amount: String(o.total || '0'), currencyCode: currency },
      totalShipping: { amount: '0', currencyCode: currency },
      itemCount: o.itemCount || (o.items ? o.items.length : 0),
      lineItems: {
        nodes: (o.items || []).map(function (i) {
          return {
            name: i.title || i.name || '',
            variantTitle: i.variant || '',
            quantity: i.qty || 1,
            currentTotalPrice: { amount: String(i.price || '0'), currencyCode: currency }
          };
        })
      },
      shippingAddress: o.shippingAddress || null,
      statusPageUrl: o.statusPageUrl || null,
      image: o.image || null,
      trackingNumber: o.trackingNumber || null,
      trackingUrl: o.trackingUrl || null
    };
  }

  function loadAccount(root) {
    var page = root.getAttribute('data-vf-page');
    var reqs = [
      api('/api/me/profile').catch(function (e) {
        if (e.code === 'not_linked' || e.code === 'http_404') return null;
        throw e;
      }),
      api('/api/me/addresses').catch(function (e) {
        if (e.code === 'not_linked') return { addresses: [], defaultId: null };
        if (e.unauthorized) throw e;
        return { addresses: [], defaultId: null };
      }),
      api('/api/me/orders?limit=25').catch(function (e) {
        if (e.unauthorized) throw e;
        return { orders: [], hasMore: false };
      })
    ];
    if (page === 'dashboard') {
      reqs.push(api('/api/me/overview').catch(function (e) {
        if (e.unauthorized) throw e;
        return null;
      }));
    }

    return Promise.all(reqs).then(function (res) {
      var profile = res[0] || {};
      var addrRes = res[1] || { addresses: [], defaultId: null };
      var orderRes = res[2] || { orders: [], hasMore: false };
      var overview = res[3] || null;
      var user = root.__vfUser || getCachedUser() || {};

      var firstName = profile.firstName || user.firstName || '';
      var lastName = profile.lastName || user.lastName || '';
      var stats = overview && overview.stats ? overview.stats : {
        orders: orderRes.orders.length,
        addresses: addrRes.addresses.length
      };
      var defaultId = addrRes.defaultId ||
        (overview && overview.defaultAddress ? overview.defaultAddress.id : null);

      return {
        firstName: firstName,
        lastName: lastName,
        displayName: [firstName, lastName].filter(Boolean).join(' ') || profile.email || user.email || '',
        emailAddress: { emailAddress: profile.email || user.email || '' },
        phoneNumber: { phoneNumber: profile.phone || '' },
        defaultAddress: defaultId ? { id: defaultId } : null,
        addresses: { nodes: addrRes.addresses.map(adaptAddress) },
        orders: { nodes: orderRes.orders.map(adaptOrder), hasMore: !!orderRes.hasMore },
        __stats: stats,
        __pendingAddress: null
      };
    });
  }

  function renderSidebarCounts(root, customer) {
    var stats = customer.__stats || {};
    var o = root.querySelector('[data-vf-count="orders"]');
    var a = root.querySelector('[data-vf-count="addresses"]');
    if (o) o.textContent = stats.orders != null ? stats.orders : customer.orders.nodes.length;
    if (a) a.textContent = stats.addresses != null ? stats.addresses : customer.addresses.nodes.length;
  }

  function bindLogout(root) {
    $all('[data-vf-logout]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        logout();
      });
    });
  }

  /* --------------------- Pedido · imagem e rastreio ------------------------ */

  function orderMedia(o, cls) {
    if (!o || !o.image) return null;
    return el('img', {
      class: cls,
      src: o.image,
      alt: '',
      loading: 'lazy',
      decoding: 'async'
    });
  }

  /* --------------------- Rastrear pedido (popup Reportana) ----------------- */

  var activeTrackModal = null;

  function trackPluginUrl(o, email) {
    var number = String(o.name || '').replace('#', '');
    var parentUrl = location.origin + '/pages/rastreio-de-pedido';
    var params = ['shop_id=30007', 'mode=iframe', 'parent_url=' + encodeURIComponent(parentUrl)];
    if (number) params.push('number=' + encodeURIComponent(number));
    if (email) params.push('email=' + encodeURIComponent(email));
    if (o.trackingNumber) params.push('code=' + encodeURIComponent(o.trackingNumber));
    params.push('t=' + Date.now());
    return 'https://app.reportana.com/order-tracking-plugin?' + params.join('&');
  }

  function closeTrackModal() {
    if (!activeTrackModal) return;
    window.removeEventListener('message', activeTrackModal.__onMsg);
    document.removeEventListener('keydown', activeTrackModal.__onKey);
    if (activeTrackModal.parentNode) activeTrackModal.parentNode.removeChild(activeTrackModal);
    document.documentElement.style.overflow = '';
    activeTrackModal = null;
  }

  function openTrackModal(o, email) {
    closeTrackModal();
    var frame = el('iframe', {
      class: 'vf-tmodal__frame',
      src: trackPluginUrl(o, email),
      title: 'Rastreamento do pedido ' + (o.name || ''),
      frameborder: '0',
      scrolling: null
    });
    var foot = [];
    if (o.trackingNumber) foot.push(el('span', { class: 'vf-meta', text: 'Código de rastreio: ' + o.trackingNumber }));
    if (o.trackingUrl) foot.push(el('a', { class: 'vf-tmodal__ext', href: o.trackingUrl, target: '_blank', rel: 'noopener', text: 'Abrir na transportadora ↗' }));

    var overlay = el('div', { class: 'vf-tmodal', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Rastrear pedido ' + (o.name || '') }, [
      el('div', { class: 'vf-tmodal__panel' }, [
        el('div', { class: 'vf-tmodal__head' }, [
          el('h4', { class: 'vf-tmodal__title', text: 'Rastrear pedido ' + (o.name || '') }),
          el('button', { class: 'vf-tmodal__close', type: 'button', 'aria-label': 'Fechar', text: '×', onclick: closeTrackModal })
        ]),
        el('div', { class: 'vf-tmodal__body' }, [frame]),
        foot.length ? el('div', { class: 'vf-tmodal__foot' }, foot) : null
      ])
    ]);

    overlay.addEventListener('click', function (ev) { if (ev.target === overlay) closeTrackModal(); });
    overlay.__onKey = function (ev) { if (ev.key === 'Escape') closeTrackModal(); };
    overlay.__onMsg = function (ev) {
      if (ev.origin !== 'https://app.reportana.com') return;
      var d = ev.data;
      var h = null;
      if (d && typeof d === 'object') h = d.height || null;
      if (h && !isNaN(Number(h))) frame.style.height = Math.min(3000, Math.max(360, Number(h))) + 'px';
    };
    document.addEventListener('keydown', overlay.__onKey);
    window.addEventListener('message', overlay.__onMsg);
    document.documentElement.style.overflow = 'hidden';
    document.body.appendChild(overlay);
    activeTrackModal = overlay;
  }

  function trackingNode(o, email) {
    if (!o) return null;
    if (o.trackingNumber || o.trackingUrl) {
      if (o.trackingNumber) {
        return el('button', {
          class: 'vf-link vf-track-link',
          type: 'button',
          text: 'Rastrear',
          onclick: function () { openTrackModal(o, email); }
        });
      }
      return el('a', {
        class: 'vf-link vf-track-link',
        href: o.trackingUrl,
        target: '_blank',
        rel: 'noopener',
        text: 'Rastrear'
      });
    }
    if (o.trackingNumber) {
      return el('span', { class: 'vf-track-code', text: 'Rastreio: ' + o.trackingNumber });
    }
    return null;
  }

  /* -------------------------------- Dashboard ------------------------------ */

  function dashboardView(customer, root) {
    var user = root.__vfUser || {};
    var stats = customer.__stats || {};
    var frag = document.createDocumentFragment();
    var profileUrl = PAGES.profile || '/pages/dados';
    var ordersUrl = PAGES.orders || '/pages/meus-pedidos';
    var addrUrl = PAGES.addresses || '/pages/enderecos';

    var email = customer.emailAddress.emailAddress || user.email || '';
    var firstName = customer.firstName || (customer.displayName || '').split(' ')[0] || '';
    var name = firstName || (email ? String(email).split('@')[0] : '') || 'sua conta';
    var initial = String(name).charAt(0).toUpperCase() || '?';

    var ordersN = stats.orders != null ? stats.orders : customer.orders.nodes.length;
    var addrN = stats.addresses != null ? stats.addresses : customer.addresses.nodes.length;
    var defaultId = customer.defaultAddress ? customer.defaultAddress.id : null;

    /* ------------------------- Saudação (avatar + sair) --------------------- */
    frag.appendChild(el('section', { class: 'vf-hero' }, [
      el('span', { class: 'vf-hero__avatar', 'aria-hidden': 'true', text: initial }),
      el('div', { class: 'vf-hero__body' }, [
        el('span', { class: 'vf-hero__eyebrow', text: 'Painel do cliente' }),
        el('h2', { class: 'vf-hero__title', text: 'Olá ' + name }),
        email ? el('span', { class: 'vf-hero__mail', text: email }) : null
      ]),
      el('button', {
        class: 'vf-hero__out', type: 'button', text: 'Sair da conta',
        onclick: function (ev) { ev.currentTarget.disabled = true; logout(); }
      })
    ]));

    /* --------------------------- Placar (sempre) ---------------------------- */
    frag.appendChild(el('div', { class: 'vf-stats' }, [
      el('div', { class: 'vf-stat' }, [
        el('span', { class: 'vf-stat__label', text: 'Pedidos' }),
        el('strong', { class: 'vf-stat__value', text: String(ordersN) }),
        el('a', { class: 'vf-stat__cta', href: ordersUrl, text: 'Ver pedidos' })
      ]),
      el('div', { class: 'vf-stat' }, [
        el('span', { class: 'vf-stat__label', text: 'Endereços' }),
        el('strong', { class: 'vf-stat__value', text: String(addrN) }),
        el('a', { class: 'vf-stat__cta', href: addrUrl, text: 'Gerenciar' })
      ])
    ]));

    /* ----------------------------- Meu cashback ---------------------------- */
    var giftbackUrl = CFG.giftbackUrl || '';
    if (giftbackUrl) {
      frag.appendChild(el('div', { style: 'margin-bottom:26px' }, [
        el('div', { class: 'vf-block-head vf-block-head--split vf-sec-head' }, [
          el('h3', { class: 'vf-h3', text: 'Meu cashback' }),
          el('a', {
            class: 'vf-link', href: giftbackUrl, target: '_blank', rel: 'noopener',
            text: 'Abrir ↗'
          })
        ]),
        el('div', { class: 'vf-card-list' }, [
          kv('Programa', 'Cashback da OGJERSEYSHOP'),
          kv('Como usar', 'Depois do pagamento o cashback vira um cupom. Use o código na finalização do próximo pedido.'),
          el('div', { class: 'vf-card-list__foot' }, [
            el('a', {
              class: 'vf-btn vf-btn--sm', href: giftbackUrl, target: '_blank', rel: 'noopener',
              text: 'Ver meu cashback'
            })
          ])
        ])
      ]));
    }

    /* --------------------------- Últimos pedidos ---------------------------- */
    frag.appendChild(el('div', { class: 'vf-block-head vf-block-head--split vf-sec-head' }, [
      el('h3', { class: 'vf-h3', text: 'Últimos pedidos' }),
      ordersN > 0 ? el('a', { class: 'vf-link', href: ordersUrl, text: 'Ver todos (' + ordersN + ')' }) : null
    ]));

    var orders = customer.orders.nodes.slice(0, 3);
    if (!orders.length) {
      frag.appendChild(el('div', { class: 'vf-empty vf-empty--hero' }, [
        el('span', {
          class: 'vf-empty__glyph', 'aria-hidden': 'true',
          html: '<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8.5 12 3.5 3 8.5v7l9 5 9-5v-7Z"/><path d="M3 8.5l9 5 9-5"/><path d="M12 13.5v7"/></svg>'
        }),
        el('strong', { text: 'Nenhum pedido ainda' }),
        el('span', { text: 'Assim que você fizer o primeiro pedido, ele aparece aqui com status e rastreio.' }),
        el('a', { class: 'vf-btn vf-btn--sm vf-empty__cta', href: '/collections', text: 'Ver produtos' })
      ]));
    } else {
      orders.forEach(function (o) {
        frag.appendChild(el('div', { class: 'vf-order' }, [
          orderMedia(o, 'vf-order__media'),
          el('div', { class: 'vf-order__main' }, [
            el('strong', { class: 'vf-order__name', text: o.name }),
            el('span', { class: 'vf-meta', text: date(o.createdAt) + ' · ' + o.itemCount + (o.itemCount === 1 ? ' item' : ' itens') })
          ]),
          el('div', { class: 'vf-order__side' }, [
            el('strong', { text: money(o.totalPrice.amount, o.totalPrice.currencyCode) }),
            el('span', { class: 'vf-tag vf-tag--' + financialTone(o.financialStatus), text: financialLabel(o.financialStatus) }),
            trackingNode(o, email)
          ])
        ]));
      });
    }

    /* --------------------------- Dados da conta ----------------------------- */
    frag.appendChild(el('div', { class: 'vf-block-head vf-sec-head', style: 'margin-top:26px' }, [
      el('h3', { class: 'vf-h3', text: 'Dados da conta' })
    ]));
    frag.appendChild(el('div', { class: 'vf-card-list' }, [
      kv('Nome', customer.displayName || '—'),
      kv('E-mail', email || '—'),
      kv('Telefone', customer.phoneNumber.phoneNumber || '—'),
      el('div', { class: 'vf-card-list__foot' }, [
        el('a', { class: 'vf-btn vf-btn--secondary vf-btn--sm', href: profileUrl, text: 'Editar dados' })
      ])
    ]));

    /* ----------------------------- Endereços -------------------------------- */
    frag.appendChild(el('div', { class: 'vf-block-head vf-block-head--split vf-sec-head', style: 'margin-top:26px' }, [
      el('h3', { class: 'vf-h3', text: 'Endereços' }),
      el('button', {
        class: 'vf-btn vf-btn--sm', type: 'button', text: 'Adicionar endereço',
        onclick: function () { openAddressForm(null, true); }
      })
    ]));

    if (customer.__pendingAddress) {
      frag.appendChild(addressForm(customer.__pendingAddress, customer, root));
    } else {
      var addrs = customer.addresses.nodes;
      if (!addrs.length) {
        frag.appendChild(el('div', { class: 'vf-empty' }, [
          el('strong', { text: 'Nenhum endereço ainda' }),
          el('span', { text: 'Salve um endereço para agilizar o checkout.' }),
          el('button', {
            class: 'vf-btn vf-btn--sm', type: 'button', text: 'Adicionar endereço',
            onclick: function () { openAddressForm(null, true); }
          })
        ]));
      } else {
        var grid = el('div', { class: 'vf-addr-grid' });
        addrs.slice(0, 3).forEach(function (a) { grid.appendChild(addressCard(a, defaultId)); });
        frag.appendChild(grid);
        if (addrs.length > 3) {
          frag.appendChild(el('div', { class: 'vf-actions', style: 'margin-top:12px' }, [
            el('a', { class: 'vf-link', href: addrUrl, text: 'Ver todos os endereços (' + addrs.length + ')' })
          ]));
        }
      }
    }

    return frag;
  }

  function kv(label, value) {
    return el('div', { class: 'vf-kv' }, [
      el('span', { class: 'vf-kv__k', text: label }),
      el('span', { class: 'vf-kv__v', text: value })
    ]);
  }

  /* --------------------------------- Orders -------------------------------- */

  var FINANCIAL_LABEL = {
    PAID: 'Pago',
    PENDING: 'Pendente',
    AUTHORIZED: 'Autorizado',
    PARTIALLY_REFUNDED: 'Reembolso parcial',
    REFUNDED: 'Reembolsado',
    VOIDED: 'Cancelado',
    EXPIRED: 'Expirado',
    PARTIALLY_PAID: 'Pago parcialmente',
    UNPAID: 'Não pago'
  };

  var FULFILLMENT_LABEL = {
    FULFILLED: 'Enviado',
    UNFULFILLED: 'Aguardando envio',
    UNSHIPPED: 'Aguardando envio',
    PARTIAL: 'Enviado parcial',
    RESTOCKED: 'Devolvido',
    ON_HOLD: 'Em retenção',
    OPENED: 'Em preparação'
  };

  function financialLabel(s) { return FINANCIAL_LABEL[s] || s || '—'; }

  function fulfillmentLabel(s) { return FULFILLMENT_LABEL[s] || s || '—'; }

  function financialTone(s) {
    if (s === 'PAID') return 'ok';
    if (s === 'PENDING' || s === 'AUTHORIZED' || s === 'PARTIALLY_PAID') return 'warn';
    if (s === 'REFUNDED' || s === 'VOIDED' || s === 'EXPIRED' || s === 'UNPAID') return 'bad';
    return 'neutral';
  }

  function fulfillmentTone(s) {
    if (s === 'FULFILLED') return 'ok';
    if (s === 'UNFULFILLED' || s === 'UNSHIPPED' || s === 'OPENED' || s === 'ON_HOLD') return 'warn';
    if (s === 'RESTOCKED') return 'bad';
    return 'neutral';
  }

  function ordersView(customer) {
    var frag = document.createDocumentFragment();
    var orders = customer.orders.nodes;
    if (orders.length) {
      frag.appendChild(el('p', { class: 'vf-meta', style: 'margin-bottom:12px', text: orders.length + (orders.length === 1 ? ' pedido' : ' pedidos') }));
    }

    if (!orders.length) {
      frag.appendChild(el('div', { class: 'vf-empty' }, [
        el('strong', { text: 'Nenhum pedido ainda' }),
        el('div', { class: 'vf-actions', style: 'margin-top:8px' }, [
          el('a', { class: 'vf-btn vf-btn--sm', href: '/collections/all', text: 'Ver produtos' })
        ])
      ]));
      return frag;
    }

    orders.forEach(function (o) {
      var lines = o.lineItems.nodes.map(function (li) {
        var title = li.name + (li.variantTitle ? ' · ' + li.variantTitle : '');
        return el('li', { class: 'vf-oli' }, [
          el('span', { class: 'vf-oli__name', text: title }),
          el('span', { class: 'vf-oli__qty', text: '×' + li.quantity })
        ]);
      });

      var head = el('div', { class: 'vf-order__head' }, [
        el('div', { class: 'vf-order__id' }, [
          orderMedia(o, 'vf-order-card__media'),
          el('div', { class: 'vf-order__id-text' }, [
            el('strong', { class: 'vf-order__name', text: o.name }),
            el('span', { class: 'vf-meta', text: 'Realizado em ' + date(o.createdAt) })
          ])
        ]),
        el('div', { class: 'vf-order__tags' }, [
          el('span', { class: 'vf-tag vf-tag--' + financialTone(o.financialStatus), text: financialLabel(o.financialStatus) }),
          el('span', { class: 'vf-tag vf-tag--' + fulfillmentTone(o.fulfillmentStatus), text: fulfillmentLabel(o.fulfillmentStatus) }),
          trackingNode(o, (customer.emailAddress && customer.emailAddress.emailAddress) || '')
        ])
      ]);

      var body = el('div', { class: 'vf-order__body' }, [
        el('ul', { class: 'vf-oli-list' }, lines),
        el('div', { class: 'vf-order__totals' }, [
          el('span', { class: 'vf-meta', text: o.itemCount + (o.itemCount === 1 ? ' item' : ' itens') }),
          el('strong', { text: money(o.totalPrice.amount, o.totalPrice.currencyCode) })
        ])
      ]);

      var actions = null;
      if (o.statusPageUrl) {
        actions = el('div', { class: 'vf-order__foot' }, [
          el('a', { class: 'vf-btn vf-btn--secondary vf-btn--sm', href: o.statusPageUrl, target: '_blank', rel: 'noopener', text: 'Acompanhar pedido' })
        ]);
      }

      frag.appendChild(el('article', { class: 'vf-order-card' }, [head, body, actions]));
    });

    return frag;
  }

  /* ------------------------------- Addresses ------------------------------- */

  var ADDR_FIELDS = [
    { name: 'firstName', label: 'Nome', required: true, autocomplete: 'given-name' },
    { name: 'lastName', label: 'Sobrenome', autocomplete: 'family-name' },
    { name: 'company', label: 'Empresa', autocomplete: 'organization' },
    { name: 'address1', label: 'Endereço', required: true, autocomplete: 'address-line1' },
    { name: 'address2', label: 'Complemento', autocomplete: 'address-line2' },
    { name: 'city', label: 'Cidade', required: true, autocomplete: 'address-level2' },
    { name: 'province', label: 'Estado', required: true, autocomplete: 'address-level1' },
    { name: 'zip', label: 'CEP', required: true, autocomplete: 'postal-code' },
    { name: 'phoneNumber', label: 'Telefone', type: 'tel', autocomplete: 'tel' }
  ];

  function addressCard(a, defaultId) {
    var isDefault = a.id === defaultId;
    var lines = [a.address1, a.address2].filter(Boolean);
    var locality = [a.city, a.province].filter(Boolean).join(' - ');

    return el('article', { class: 'vf-addr' + (isDefault ? ' is-default' : '') }, [
      el('header', { class: 'vf-addr__head' }, [
        el('strong', { text: [a.firstName, a.lastName].filter(Boolean).join(' ') || 'Endereço' }),
        isDefault ? el('span', { class: 'vf-tag vf-tag--ok', text: 'Principal' }) : null
      ]),
      el('div', { class: 'vf-addr__body' }, [
        lines.map(function (l) { return el('div', { text: l }); }),
        el('div', { text: locality }),
        el('div', { text: a.zip || '' }),
        el('div', { text: a.country || a.countryCode || '' }),
        a.phoneNumber ? el('div', { class: 'vf-meta', text: a.phoneNumber }) : null
      ].flat()),
      el('footer', { class: 'vf-addr__foot' }, [
        el('button', { class: 'vf-link', type: 'button', text: 'Editar', onclick: function () { openAddressForm(a, false); } }),
        isDefault ? null : el('button', { class: 'vf-link', type: 'button', text: 'Tornar principal', onclick: function () { setDefault(a); } }),
        el('button', { class: 'vf-link vf-link--danger', type: 'button', text: 'Excluir', onclick: function () { removeAddress(a); } })
      ])
    ]);
  }

  function addressesView(customer, root) {
    var frag = document.createDocumentFragment();
    var nodes = customer.addresses.nodes;
    var defaultId = customer.defaultAddress ? customer.defaultAddress.id : null;

    frag.appendChild(el('div', { class: 'vf-block-head vf-block-head--split' }, [
      nodes.length ? el('p', { class: 'vf-meta', text: nodes.length + (nodes.length === 1 ? ' endereço salvo' : ' endereços salvos') }) : null,
      el('button', { class: 'vf-btn vf-btn--sm', type: 'button', text: 'Adicionar endereço', onclick: function () { openAddressForm(null, true); } })
    ]));

    if (customer.__pendingAddress) {
      frag.appendChild(addressForm(customer.__pendingAddress, customer, root));
    }

    if (!nodes.length && !customer.__pendingAddress) {
      frag.appendChild(el('div', { class: 'vf-empty' }, [
        el('strong', { text: 'Nenhum endereço ainda' }),
        el('span', { text: 'Salve um endereço para agilizar o checkout.' })
      ]));
      return frag;
    }

    var grid = el('div', { class: 'vf-addr-grid' });
    nodes.forEach(function (a) { grid.appendChild(addressCard(a, defaultId)); });
    frag.appendChild(grid);
    return frag;
  }

  function addressForm(state, customer, root) {
    var isNew = !state.id;
    var form = el('form', { class: 'vf-form vf-addr-form', novalidate: null });
    form.appendChild(el('div', { class: 'vf-block-head' }, [
      el('h3', { class: 'vf-h3', text: isNew ? 'Novo endereço' : 'Editar endereço' })
    ]));

    ADDR_FIELDS.forEach(function (f) {
      var id = 'vf-addr-' + f.name;
      form.appendChild(el('div', { class: 'vf-field' }, [
        el('label', { class: 'vf-label', for: id, text: f.label + (f.required ? '' : ' (opcional)') }),
        el('input', {
          class: 'vf-input', id: id, name: f.name, type: f.type || 'text',
          autocomplete: f.autocomplete || null, required: f.required ? 'required' : null,
          value: state[f.name] || ''
        })
      ]));
    });

    var country = el('select', { class: 'vf-select', id: 'vf-addr-country', name: 'country' });
    Object.keys(COUNTRY_NAMES).forEach(function (code) {
      var opt = el('option', { value: code, text: COUNTRY_NAMES[code] });
      if ((state.countryCode || 'BR') === code) opt.selected = true;
      country.appendChild(opt);
    });
    form.appendChild(el('div', { class: 'vf-field' }, [
      el('label', { class: 'vf-label', for: 'vf-addr-country', text: 'País' }),
      country
    ]));

    form.appendChild(el('label', { class: 'vf-check' }, [
      el('input', { type: 'checkbox', name: 'isDefault', checked: state.isDefault ? 'checked' : null }),
      el('span', { text: 'Definir como endereço principal' })
    ]));

    form.appendChild(el('p', { class: 'vf-note vf-note--error', role: 'alert' }));

    form.appendChild(el('div', { class: 'vf-actions' }, [
      el('button', { class: 'vf-btn', type: 'submit', text: isNew ? 'Salvar endereço' : 'Atualizar endereço' }),
      el('button', {
        class: 'vf-btn vf-btn--secondary', type: 'button', text: 'Cancelar',
        onclick: function () { customer.__pendingAddress = null; rerender(root); }
      })
    ]));

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var fd = new FormData(form);
      var note = $('.vf-note--error', form);
      var code = String(fd.get('country') || 'BR');
      var payload = {
        firstName: String(fd.get('firstName') || '').trim(),
        lastName: String(fd.get('lastName') || '').trim(),
        company: String(fd.get('company') || '').trim(),
        address1: String(fd.get('address1') || '').trim(),
        address2: String(fd.get('address2') || '').trim(),
        city: String(fd.get('city') || '').trim(),
        province: String(fd.get('province') || '').trim(),
        zip: String(fd.get('zip') || '').trim(),
        country: COUNTRY_NAMES[code] || code,
        countryCode: code,
        phone: e164(fd.get('phoneNumber')),
        isDefault: !!fd.get('isDefault')
      };

      if (!payload.firstName || !payload.address1 || !payload.city || !payload.province || !payload.zip) {
        note.textContent = 'Preencha os campos obrigatórios do endereço.';
        return;
      }

      var btn = $('button[type=submit]', form);
      btn.disabled = true;
      var req = state.id
        ? api('/api/me/addresses/' + state.id, { method: 'PUT', body: payload })
        : api('/api/me/addresses', { method: 'POST', body: payload });

      req.then(function () {
        customer.__pendingAddress = null;
        rerender(root, true);
      }).catch(function (err) {
        btn.disabled = false;
        note.textContent = msg(err);
      });
    });

    return form;
  }

  function openAddressForm(a, isNew) {
    var root = document.querySelector('[data-vf-root]');
    var customer = root && root.__vfCustomer;
    if (!customer) return;
    customer.__pendingAddress = a
      ? Object.assign({}, a, { countryCode: a.countryCode || 'BR' })
      : { firstName: customer.firstName || '', lastName: customer.lastName || '', countryCode: 'BR', isDefault: customer.addresses.nodes.length === 0 };
    rerender(root);
    var form = $('.vf-addr-form');
    if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function saveAddressMut(root, req, okMsg) {
    var view = $('[data-vf-view]', root);
    var customer = root.__vfCustomer;
    req.then(function () {
      rerender(root, true);
    }).catch(function (err) {
      viewError(view, err);
    });
  }

  function setDefault(a) {
    var root = document.querySelector('[data-vf-root]');
    saveAddressMut(root, api('/api/me/addresses/' + a.id, {
      method: 'PUT',
      body: Object.assign({
        firstName: a.firstName, lastName: a.lastName, company: a.company,
        address1: a.address1, address2: a.address2, city: a.city, province: a.province,
        zip: a.zip, country: a.country || COUNTRY_NAMES[a.countryCode] || a.countryCode,
        countryCode: a.countryCode, phone: a.phoneNumber, isDefault: true
      })
    }));
  }

  function removeAddress(a) {
    if (!window.confirm('Excluir este endereço?')) return;
    var root = document.querySelector('[data-vf-root]');
    saveAddressMut(root, api('/api/me/addresses/' + a.id, { method: 'DELETE' }));
  }

  /* --------------------------------- Profile -------------------------------- */

  function profileView(customer, root) {
    var frag = document.createDocumentFragment();

    var form = el('form', { class: 'vf-form', novalidate: null });
    form.appendChild(el('div', { class: 'vf-field-row' }, [
      el('div', { class: 'vf-field' }, [
        el('label', { class: 'vf-label', for: 'vf-profile-first', text: 'Nome' }),
        el('input', { class: 'vf-input', id: 'vf-profile-first', name: 'firstName', type: 'text', autocomplete: 'given-name', required: 'required', value: customer.firstName })
      ]),
      el('div', { class: 'vf-field' }, [
        el('label', { class: 'vf-label', for: 'vf-profile-last', text: 'Sobrenome' }),
        el('input', { class: 'vf-input', id: 'vf-profile-last', name: 'lastName', type: 'text', autocomplete: 'family-name', value: customer.lastName })
      ])
    ]));

    form.appendChild(el('div', { class: 'vf-field' }, [
      el('label', { class: 'vf-label', for: 'vf-profile-email', text: 'E-mail' }),
      el('input', { class: 'vf-input', id: 'vf-profile-email', type: 'email', value: customer.emailAddress.emailAddress, readonly: 'readonly' }),
      el('span', { class: 'vf-note', text: 'O e-mail de acesso não pode ser alterado por aqui.' })
    ]));

    form.appendChild(el('div', { class: 'vf-field' }, [
      el('label', { class: 'vf-label', for: 'vf-profile-phone', text: 'Telefone' }),
      el('input', { class: 'vf-input', id: 'vf-profile-phone', name: 'phone', type: 'tel', autocomplete: 'tel', placeholder: '+5511999990000', value: customer.phoneNumber.phoneNumber })
    ]));

    form.appendChild(el('p', { class: 'vf-note vf-note--error', role: 'alert' }));

    form.appendChild(el('div', { class: 'vf-actions' }, [
      el('button', { class: 'vf-btn', type: 'submit', text: 'Salvar alterações' }),
      el('button', {
        class: 'vf-btn vf-btn--secondary', type: 'button', text: 'Cancelar',
        onclick: function () { rerender(root); }
      })
    ]));

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var fd = new FormData(form);
      var note = $('.vf-note--error', form);
      var firstName = String(fd.get('firstName') || '').trim();
      if (!firstName) { note.textContent = 'Informe seu nome.'; return; }
      var btn = $('button[type=submit]', form);
      btn.disabled = true;
      api('/api/me/profile', {
        method: 'PUT',
        body: {
          firstName: firstName,
          lastName: String(fd.get('lastName') || '').trim(),
          phone: e164(fd.get('phone')) || null
        }
      }).then(function () {
        rerender(root, true);
      }).catch(function (err) {
        btn.disabled = false;
        note.textContent = msg(err);
      });
    });

    frag.appendChild(el('div', { class: 'vf-card-list' }, [form]));

    return frag;
  }

  /* --------------------------------- Router --------------------------------- */

  var VIEWS = {
    dashboard: dashboardView,
    orders: ordersView,
    addresses: addressesView,
    profile: profileView
  };

  function paint(root, customer) {
    var view = $('[data-vf-view]', root);
    if (!view) return;
    var page = root.getAttribute('data-vf-page');
    var fn = VIEWS[page];
    view.innerHTML = '';
    view.appendChild(fn ? fn(customer, root) : el('p', { class: 'vf-meta', text: 'Página não encontrada.' }));
    renderSidebarCounts(root, customer);
  }

  function rerender(root, reload) {
    var customer = root.__vfCustomer;
    if (!customer) return;
    if (reload) {
      var view = $('[data-vf-view]', root);
      if (view) skeleton(view);
      loadAccount(root).then(function (fresh) {
        root.__vfCustomer = fresh;
        paint(root, fresh);
      }).catch(function (err) {
        if (err.unauthorized || err.status === 401 || err.status === 403) {
          clearVfStorage();
          location.replace(LOGIN_URL + '?out=1');
          return;
        }
        viewError(view, err);
      });
    } else {
      paint(root, customer);
    }
  }

  function bootProtected(root) {
    var view = $('[data-vf-view]', root);
    if (view) skeleton(view);
    ensureAuth(root, view).then(function (ok) {
      if (!ok) return;
      return loadAccount(root).then(function (customer) {
        root.__vfCustomer = customer;
        paint(root, customer);
      }).catch(function (err) {
        if (err.unauthorized || err.status === 401 || err.status === 403) {
          clearVfStorage();
          location.replace(LOGIN_URL + '?out=1');
          return;
        }
        viewError(view, err);
      });
    });
  }

  function boot() {
    var root = document.querySelector('[data-vf-root]');
    if (!root) return;
    var page = root.getAttribute('data-vf-page');
    bindLogout(root);
    if (page === 'login') bootLogin(root);
    else bootProtected(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.VF = { cfg: CFG, api: api, logout: logout, getToken: getToken };
})();
